import { css, styled } from 'styled-components';

export const CalendarWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  color: ${({ theme }) => theme.colors.text.white};
  z-index: 9999;
  height: 100%;
  width: 100%;
`;

export const CalendarToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const CalendarToolBarIconWrapper = styled.div`
  display: flex;
  gap: 8px;
  color: rgb(var(--content-base-default));
`;

export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-auto-rows: minmax(20px, 1fr);
  gap: 16px;
  padding: 8px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: rgb(var(--content-base-default));
  width: 100%;
`;

export const CalendarHeaderCell = styled.span`
  line-height: 20px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: rgb(var(--content-base-subdued));
  width: 100%;
`;

export const CalendarDayCell = styled.button<{
  $selected?: boolean;
  $today?: boolean;
  $weekend?: boolean;
  $outside?: boolean;
}>`
  all: unset;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  cursor: pointer;
  color: rgb(var(--content-base-default));
  text-align: center;
  /* Body/Large/Medium */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;

  ${({ $weekend, $selected }) =>
    $weekend &&
    !$selected &&
    css`
      color: rgb(var(--content-base-subdued));
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
    `}

  ${({ $outside, $selected }) =>
    $outside &&
    !$selected &&
    css`
      color: rgb(var(--content-base-subdued));
      opacity: 0.5;
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;

      &:hover {
        opacity: 1;
      }
    `}



  &:disabled {
    color: ${({ theme }) => theme.colors.text.primary};
  }

  ${({ $selected }) =>
    $selected &&
    css`
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-color: rgb(var(--neutral-500) / 0.12);
        z-index: 0;
      }

      color: rgb(var(--content-base-default));
      text-align: center;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
    `}

  &:hover {
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-color: rgb(var(--neutral-500) / 0.12);
      z-index: 0;
    }

    color: rgb(var(--content-base-default));
    text-align: center;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }

  ${({ $today }) =>
    $today &&
    css`
      color: #9796f3;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
      text-align: center;

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-color: rgba(151, 150, 243, 0.08);
        z-index: 0;
      }
    `}
`;

export const CalendarGridWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
`;
